import { useSelector } from 'react-redux';
import { determineIfUserHasAccessToResource } from '../HelperMethods/UserUtilities';

const useAuthorization = ({ resourceType, resource, entityAccessType, entity }) => {
  const user = useSelector((state) => state.appReducer.loggedInUser);
  const settings = useSelector((state) => state.appReducer.settings);
  const packagesInfo = useSelector((state) => state.appReducer.packagesInfo);

  return determineIfUserHasAccessToResource({
    resourceType,
    resource,
    entityAccessType,
    entity,
    user,
    packageName: settings?.package,
    packagesInfo,
  });
};

export default useAuthorization;
